import {
  ActionHeader,
  Strong,
  StyledDarkSectionTitle,
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import { useEffect, useState, Suspense, useRef } from "react";
import { useOutletContext } from "react-router-dom";
import { BookingQueueContainer } from "./styles";
import { labels } from "@/util/label";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import {
  hasCheckSecurity,
  isNonEmptyVariable,
  toQueryString,
} from "@/util/common_function";
import dayjs from "dayjs";
import DataTable from "@/common/elements/DataTable";
import BookingsPage from "../Bookings";
import Modal from "@/common/elements/Modal";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Button from "@/common/elements/Button";
import { setBookingsNull } from "@/slices/bookingsSlice";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID } from "@/util/common_variable";
import NoAccess from "@/components/BookingsDetails/NoAccess";

const ReleaseQueue = () => {
  const { bookingQueueFilter } = useSelector((state) => state?.bookingQueue);
  const { headerHeight } = useOutletContext();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const datatableRef = useRef();
  const dispatch = useDispatch();
  const [showStepModal, setShowStepModal] = useState(false);
  const [loadingAPI, setLoadingAPI] = useState(false);
  const [nextBookingStep, setNextBookingStep] = useState(null);
  const [releaseQueueData, setReleaseQueueData] = useState({
    total: 0,
    headers: [
      { key: "booking", text: labels.booking },
      { key: "name", text: labels.name },
      { key: "currentloc", text: labels.currentLocation },
      { key: "scheduledDate", text: "Scheduled Release  Date" },
      { key: "charge", text: "Charge" },
      { key: "releaseReason", text: "Release Reason" },
      { key: "releaseTO", text: "Release To" },
    ],
    rows: [],
  });
  const [selectRQ, setSelectRQ] = useState(null);

  const prevFilterRef = useRef(bookingQueueFilter);
  const prevPaginationRef = useRef(pagination);
  const [isFilterChanged, setisFilterChanged] = useState(false);

  useEffect(() => {
    getReleaseQueue();
  }, []);

  useEffect(() => {
    const isFilterChangedLocal =
      JSON.stringify(prevFilterRef?.current) !==
      JSON.stringify(bookingQueueFilter);

    setisFilterChanged(() => isFilterChangedLocal);
    prevFilterRef.current = bookingQueueFilter;

    const isPaginationChanged =
      JSON.stringify(prevPaginationRef?.current) !== JSON.stringify(pagination);
    prevPaginationRef.current = pagination;

    if (isFilterChangedLocal && bookingQueueFilter?.length) {
      setPagination((prev) => ({
        pageIndex: 0,
        pageSize: 10,
      }));

      getReleaseQueue();
    }

    if (isPaginationChanged) {
      getReleaseQueue();
    }
  }, [bookingQueueFilter, pagination]);

  // useEffect(() => {
  //   if (!loadingAPI && bookingQueueFilter?.length) {
  //     getReleaseQueue();
  //   }
  // }, [pagination]);

  const getReleaseQueue = () => {
    setLoadingAPI(true);
    const sf = JSON.parse(JSON.stringify(bookingQueueFilter));
    const data = sf?.map((sf) => {
      if (
        sf?.filterKey == "incarcerationDate" &&
        isNonEmptyVariable(sf?.value)
      ) {
        sf.value = dayjs(sf?.value)?.format("MM/DD/YYYY");
      }

      if (sf?.filterKey == "dob" && isNonEmptyVariable(sf?.value)) {
        sf.value = dayjs(sf?.value)?.format("MM/DD/YYYY");
      }

      return sf;
    });

    const text = JSON.stringify(data);
    let url = API_ENDPOINTS.releaseQueueList;
    const obj = {
      page: isFilterChanged ? 0 : pagination?.pageIndex,
      size: isFilterChanged ? 10 : pagination?.pageSize,
      direction: "DESC",
    };
    const urlParam = toQueryString(obj);
    if (isNonEmptyVariable(urlParam)) {
      url += "?" + urlParam;
    }
    api
      .post(url, text)
      .then((response) => {
        const { total, rows, size } = response?.data;

        const capitalize = (str) =>
          str && str.charAt(0).toUpperCase() + str.slice(1);

        const bookData = {
          total: total,
          size: size,
          rows: rows.map((book) => {
            const fName = capitalize(book?.bio?.[0]?.fName || "");
            const lName = capitalize(book?.bio?.[0]?.lName || "");
            const mName = capitalize(book?.bio?.[0]?.mName || "");
            return {
              booking: book?.bookingNo || "",
              firstName: book?.bio?.[0]?.fName,
              lastName: book?.bio?.[0]?.lName,
              name: `${lName} ${fName} ${mName}`.trim(),
              currentloc: book?.currentLocation || "",
              scheduledDate: book?.scheduledDate || "",
              releaseReason: book?.releaseReason || "",
              releaseTO: book?.releaseTO || "",
            };
          }),
        };

        setReleaseQueueData((prev) => ({ ...prev, ...bookData }));
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
        } else {
          console.error("An error occurred:", error);
        }
      })
      .finally(() => {
        setLoadingAPI(false);
      });
  };

  const onSelectRQ = (val) => {
    setSelectRQ(val);
  };

  const handleReleaseStep = () => {
    const obj = {
      key: "personal-information",
      value: selectRQ,
    };
    dispatch(setBookingsNull());
    setNextBookingStep(obj);
    setShowStepModal(true);
  };

  const handleReleaseStepModal = () => {
    setShowStepModal(() => false);
    setSelectRQ(() => null);
    datatableRef?.current?.resetAll();
  };

  const bqCompleteSaveAction = () => {
    setShowStepModal(() => false);
    setSelectRQ(() => null);
    datatableRef?.current?.resetAll();
    getReleaseQueue();
  };

  return (
    <>
      <StyledGridRow justify="space-between">
        <StyledGridCol span={24}>
          <StyledDarkSectionTitle bgColor="rgb(4 28 45)">
            <span>Release Queue</span>
          </StyledDarkSectionTitle>
        </StyledGridCol>
      </StyledGridRow>
      {hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.module,
        LABELS_CAPITAL.VIEW,
        MODULES_LIST_WITH_ID.MODULE_RELEASESQUEUE
      ) ? (
        <BookingQueueContainer>
          <ActionHeader
            headerHeight={headerHeight}
            style={{ marginBottom: "10px" }}
            className="queue-action-header"
          >
            <div className="left">
              <StyledFlex align="center" gap="10px">
                <Button
                  color="primary"
                  type="primary"
                  variant="solid"
                  onClick={handleReleaseStep}
                  disabled={
                    selectRQ === null ||
                    loadingAPI ||
                    !hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.module,
                      LABELS_CAPITAL.ADD,
                      MODULES_LIST_WITH_ID.MODULE_RELEASESQUEUE
                    )
                  }
                >
                  Booking Details
                </Button>
              </StyledFlex>
              <StyledFlex align="center" gap="10px">
                <Button
                  color="primary"
                  type="primary"
                  variant="solid"
                  onClick={handleReleaseStepModal}
                  disabled={selectRQ === null || loadingAPI}
                >
                  cancel
                </Button>
              </StyledFlex>
            </div>
            <div className="right">
              <Strong>{releaseQueueData?.total} Results</Strong>
            </div>
          </ActionHeader>

          <DataTable
            ref={datatableRef}
            width="100%"
            totalRecords={releaseQueueData?.total}
            headers={releaseQueueData?.headers}
            data={releaseQueueData?.rows}
            allowTableSorting={true}
            pagination={pagination}
            setPagination={setPagination}
            showCheckbox={false}
            rowUniqueId={"booking"}
            onRowClick={onSelectRQ}
            isAPiCallLoading={loadingAPI}
            noDataMessage="No Release queue found"
          />
        </BookingQueueContainer>
      ) : (
        <NoAccess />
      )}

      {/* Modal */}
      {showStepModal && (
        <Modal
          designPattern="ant"
          header={"Bookings"}
          show={showStepModal}
          onHide={handleReleaseStepModal}
          size="xxl"
          backdrop="static"
          footerActionsNeed={false}
          // footerCloseAction
          // footerCloseActionText="Cancel"
          width={"95%"}
        >
          <Suspense fallback={<p>Loading...</p>} style={{ minHeight: "300px" }}>
            <BookingsPage
              isBQ={true}
              nextBookingStep={nextBookingStep}
              bqCompleteSaveAction={bqCompleteSaveAction}
            />
          </Suspense>
        </Modal>
      )}
    </>
  );
};

export default ReleaseQueue;
